// removed by extract-text-webpack-plugin
module.exports = {"mainBox":"AuthenticationFailed__mainBox___17d6q","errorDiv":"AuthenticationFailed__errorDiv___2zY0h","imageClass":"AuthenticationFailed__imageClass___qz13h"};


//////////////////
// WEBPACK FOOTER
// ./src/dialogs/AuthenticationFailed/AuthenticationFailed.scss
// module id = 733
// module chunks = 0